import {
  Confirmation,
  SoccerIncidentId,
} from '@collector/sportsapi-client-legacy'

import { IncidentsTeamPossessionConfig } from '../../configuration'

export const incidentsTeamPossessionConfig: IncidentsTeamPossessionConfig<SoccerIncidentId> =
  {
    defaultPossessionIncidents: new Set([
      SoccerIncidentId.WaterBreak,
      SoccerIncidentId.RefereesInjury,
      SoccerIncidentId.BreakDuringTheGame,
      SoccerIncidentId.ExtratimeFirstHalf,
      SoccerIncidentId.ExtratimeSecondHalf,
    ]),
    changePossessionIncidents: {
      [SoccerIncidentId.Goal]: {
        toTeamPossession: 'opposite',
        shouldBeTriggered: (incidentUpdate) =>
          // incident was confirmed or cancelled
          incidentUpdate.currentData?.confirmation === Confirmation.ToBeDone &&
          [Confirmation.Confirmed, Confirmation.Cancelled].includes(
            incidentUpdate.data.confirmation,
          ),
      },
      [SoccerIncidentId.Penalty]: { toTeamPossession: 'current' },
      [SoccerIncidentId.Corner]: { toTeamPossession: 'current' },
      [SoccerIncidentId.ShotOnTarget]: { toTeamPossession: 'current' },
      [SoccerIncidentId.ShotOffTarget]: { toTeamPossession: 'current' },
      [SoccerIncidentId.ShotBlocked]: { toTeamPossession: 'current' },
      [SoccerIncidentId.ThrowIn]: { toTeamPossession: 'current' },
      [SoccerIncidentId.Offside]: { toTeamPossession: 'opposite' },
      [SoccerIncidentId.Foul]: { toTeamPossession: 'opposite' },
      [SoccerIncidentId.PenaltySavedByGoalkeeper]: {
        toTeamPossession: 'current',
      },
      [SoccerIncidentId.MissedPenalty]: { toTeamPossession: 'current' },
      [SoccerIncidentId.GoalKick]: { toTeamPossession: 'current' },
      [SoccerIncidentId.Attack]: { toTeamPossession: 'current' },
      [SoccerIncidentId.DangerousAttack]: { toTeamPossession: 'current' },
      [SoccerIncidentId.InPossession]: { toTeamPossession: 'current' },
    },
  }
